import {
    computePosition,
    offset,
    shift,
    flip,
    arrow,
} from '@floating-ui/dom';
import Blue from "~/core";
window.process = {
    env: {
      NODE_ENV: 'production'
    }
}
new Blue({
  name: "tooltips",
  selector: ".js-tooltip",
  setup(tooltips) {
    const tooltip = document.getElementById(tooltips.getAttribute('aria-describedby'))
    const arrowEl = tooltip.querySelector('.tooltip__arrow')
    
    function update() {
        computePosition(tooltips, tooltip, {
            placement: 'top',
            middleware: [
                offset(10), 
                flip(), 
                shift({padding: 5}),
                arrow({element: arrowEl})
            ],
        }).then(({x, y, placement, middlewareData}) => {
            Object.assign(tooltip.style, {
                left: `${x}px`,
                top: `${y}px`,
            })
            const {x: arrowX, y: arrowY} = middlewareData.arrow
            const staticSide = {
                top: 'bottom',
                right: 'left',
                bottom: 'top',
                left: 'right',
              }[placement.split('-')[0]]
             
              Object.assign(arrowEl.style, {
                left: arrowX != null ? `${arrowX}px` : '',
                top: arrowY != null ? `${arrowY}px` : '',
                right: '',
                bottom: '',
                [staticSide]: '-4px',
              });
        })
      }
       
      function showTooltip() {
        tooltip.style.display = 'block';
        update();
      }
       
      function hideTooltip() {
        tooltip.style.display = '';
      }
       
      [
        ['mouseenter', showTooltip],
        ['mouseleave', hideTooltip],
        ['focus', showTooltip],
        ['blur', hideTooltip],
      ].forEach(([event, listener]) => {
        tooltips.addEventListener(event, listener);
      });
  }
})
